import { fromJS } from 'immutable';

import { getAllIds } from 'utils/normaliseResponse';

import { projectColorPicker } from 'utils/projectHelpers';

import * as constants from 'actions/projects/constants';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ALL_PROJECTS_SUCCESS: {
      const projects = action.projects.filter(
        ({ roles, group_roles }) =>
          roles.includes('admin') ||
          group_roles.find((group) => group.roles.includes('group_coordinator'))
      );
      return state
        .set('allProjects', fromJS(projects))
        .set('colors', fromJS(projectColorPicker(projects.length)));
    }
    case constants.SET_ACTIVE_PROJECT_ID:
      // We cast the ID to a string because it reflects byId object keys, which
      // can only be strings
      return state.set('activeProjectId', `${action.projectId}`);

    case constants.GET_PROJECT_DETAILS_SUCCESS: {
      const projectId = `${action.projectId}`;

      const prevAllIds = state.get('allIds') || fromJS([]);
      const allIds = getAllIds([projectId], prevAllIds);

      return state
        .mergeDeep(
          fromJS({
            byId: {
              [projectId]: action.projectDetails
            }
          })
        )
        .set('allIds', allIds);
    }

    default:
      return state;
  }
};
